<div class="wrapper">
  <app-sidebar />

  <app-topbar  [title]="title" [subTitle]="subTitle" (settingsButtonClicked)="onSettingsButtonClicked()" (mobileMenuButtonClicked)="onToggleMobileMenu()" />
  <div class="page-content">
    <div class="page-container">
      <router-outlet (activate)="onActivate($event)" />
    </div>

    <app-footer class="mt-auto" />

  </div>

</div>